// QuickReplies — Presentational block rendering the quick-reply chip buttons
// attached to a bot chat message.
//
// Extracted verbatim from `AIChatBot.js` (the quick-reply chips block inside
// the in-file `ChatMessageBubble` sub-component) as part of the
// behavior-preserving refactor (issue #240). Render-only, wrapped in
// React.memo. Markup, styles, hover handlers, disabled/opacity guards, and the
// `reply.value` keying are identical to the source.
//
// The parent (`ChatMessageBubble`) keeps the source's
// `message.quickReplies && message.quickReplies.length > 0` render guard, so
// this component is only mounted when there is at least one reply; it renders
// the inner chip container exactly as the source did.
//
// Props:
//   replies     - array of { label, value } quick replies
//   isLoading   - boolean, disables the chips and dims them while loading
//   onQuickReply - callback invoked with reply.value when a chip is clicked
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const QuickReplies = React.memo(function QuickReplies({ replies, isLoading, onQuickReply }) {
  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px',
      marginTop: '8px'
    }}>
      {replies.map((reply) => (
        <button
          key={reply.value}
          onClick={() => onQuickReply(reply.value)}
          disabled={isLoading}
          style={{
            padding: '6px 12px',
            backgroundColor: '#ffffff',
            color: '#374151',
            border: '1.5px solid #d1d5db',
            borderRadius: '999px',
            fontSize: '13px',
            fontWeight: '500',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.15s',
            opacity: isLoading ? 0.6 : 1,
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = '#667eea';
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.borderColor = '#667eea';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ffffff';
            e.currentTarget.style.color = '#374151';
            e.currentTarget.style.borderColor = '#d1d5db';
          }}
        >
          {reply.label}
        </button>
      ))}
    </div>
  );
});

export default QuickReplies;
